import geolocation from "./geolocation";

export const defaultGeolocationHelper = () => {
	return geolocation.watchPositionSync();
};